import script from "./trade.vue?vue&type=script&setup=true&lang=ts"
export * from "./trade.vue?vue&type=script&setup=true&lang=ts"

import "./trade.vue?vue&type=style&index=0&id=1a29be5f&scoped=true&lang=css"

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a29be5f"]])

export default __exports__